// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BookRecordModals Styles */

.issue-modal,
.return-modal {
  max-width: 1300px;
  width: 100%;
}

.issue-modal .modal-header,
.return-modal .modal-header {
  padding: 1.5rem 2rem;
}

.issue-modal .modal-title,
.return-modal .modal-title {
  font-size: 1.375rem;
}

.issue-modal .modal-body,
.return-modal .modal-body {
  padding: 1rem 1.25rem;
}

.issue-modal .modal-actions,
.return-modal .modal-actions {
  padding: 0.75rem 1.25rem;
  gap: 0.75rem;
}

.book-detail-preview {
  background-color: var(--slate-50);
  border-radius: var(--radius-lg);
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  border: 1px solid var(--slate-100);
}

.book-detail-grid {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 1rem;
  align-items: start;
}

.book-detail-cover {
  width: 120px;
  height: 180px;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--bg-secondary);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.book-detail-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.book-detail-cover-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
}

.book-detail-cover-placeholder .material-symbols-outlined {
  font-size: 64px;
}

.book-detail-info {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.book-detail-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.9375rem;
}

.book-detail-row:last-child {
  margin-bottom: 0;
}

.book-detail-label {
  font-weight: 600;
  color: var(--text-sub);
  min-width: 90px;
  flex-shrink: 0;
}

.book-detail-value {
  color: var(--text-main);
  font-weight: 500;
}

.book-info-summary {
  background-color: var(--slate-50);
  border-radius: var(--radius-lg);
  padding: 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid var(--slate-100);
}

.book-info-summary p {
  margin: 0.5rem 0;
  font-size: 0.875rem;
  color: var(--text-sub);
}

.book-info-summary p:first-child {
  margin-top: 0;
}

.book-info-summary p:last-child {
  margin-bottom: 0;
}

.book-info-summary strong {
  color: var(--text-main);
  font-weight: 600;
}

/* Form Groups */
.issue-modal .form-group,
.return-modal .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-bottom: 0.625rem;
}

.issue-modal .form-group:last-child,
.return-modal .form-group:last-child {
  margin-bottom: 0;
}

.issue-modal .form-label,
.return-modal .form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
}

.issue-modal .form-input,
.issue-modal .form-textarea,
.return-modal .form-input,
.return-modal .form-textarea {
  padding: 0.45rem 0.75rem;
  font-size: 0.9375rem;
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  transition: all var(--transition-fast);
}

.issue-modal .form-input:focus,
.issue-modal .form-textarea:focus,
.return-modal .form-input:focus,
.return-modal .form-textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);
  outline: none;
}

.issue-modal .form-input::placeholder,
.return-modal .form-input::placeholder {
  color: var(--slate-400);
}

/* Combobox */
.combobox-container {
  position: relative;
}

.combobox-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: var(--surface-light);
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  max-height: 200px;
  overflow-y: auto;
  z-index: 50;
  margin-top: 0.25rem;
  list-style: none;
  padding: 0.25rem 0;
}

.combobox-option {
  padding: 0.625rem 1rem;
  cursor: pointer;
  font-size: 0.9375rem;
  color: var(--text-main);
  transition: background-color var(--transition-fast);
}

.combobox-option:hover {
  background-color: var(--slate-50);
}

.combobox-option.no-results {
  color: var(--text-sub);
  cursor: default;
}

.combobox-option.no-results:hover {
  background-color: transparent;
}

/* Book dropdown specific styles */
.book-dropdown {
  max-height: 400px;
  max-width: 600px;
}

.book-option {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--slate-100);
}

.book-option:last-child {
  border-bottom: none;
}

.book-option-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.book-option-title {
  font-weight: 600;
  color: var(--text-main);
  font-size: 0.9375rem;
}

.book-option-author {
  font-size: 0.8125rem;
  color: var(--text-sub);
}

.book-option-meta {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin-top: 0.125rem;
}

.book-option:hover .book-option-title {
  color: var(--primary-color);
}

/* Required marker */
.required {
  color: var(--error-text);
}

/* Responsive */
@media (max-width: 768px) {
  .issue-modal .modal-header,
  .return-modal .modal-header {
    padding: 0.75rem 1rem;
  }

  .issue-modal .modal-body,
  .return-modal .modal-body {
    padding: 0.75rem 1rem;
  }

  .issue-modal .modal-actions,
  .return-modal .modal-actions {
    padding: 0.75rem 1rem;
  }

  .book-detail-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .book-detail-cover {
    width: 100%;
    max-width: 120px;
    height: 180px;
    margin: 0 auto;
  }

  .book-detail-cover-placeholder {
    max-width: 120px;
    margin: 0 auto;
  }
}

.form-help {
  font-size: 0.75rem;
  color: var(--slate-500);
  margin-top: 0.375rem;
}

.loading-shelves {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  color: var(--slate-500);
  font-size: 0.875rem;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-shelves-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem;
  text-align: center;
  color: var(--slate-400);
  background-color: var(--slate-50);
  border-radius: var(--radius-md);
  border: 1px dashed var(--slate-200);
}

.no-shelves-message .material-symbols-outlined {
  font-size: 2.5rem;
  color: var(--slate-300);
}

.no-shelves-message p {
  margin: 0;
  font-size: 0.875rem;
}

.no-shelves-message .help-text {
  font-size: 0.75rem;
  color: var(--slate-400);
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/BookRecordModals.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sFAAsF;EACtF,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;EAIE,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;;;EAIE,4BAA4B;EAC5B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":["/* BookRecordModals Styles */\n\n.issue-modal,\n.return-modal {\n  max-width: 1300px;\n  width: 100%;\n}\n\n.issue-modal .modal-header,\n.return-modal .modal-header {\n  padding: 1.5rem 2rem;\n}\n\n.issue-modal .modal-title,\n.return-modal .modal-title {\n  font-size: 1.375rem;\n}\n\n.issue-modal .modal-body,\n.return-modal .modal-body {\n  padding: 1rem 1.25rem;\n}\n\n.issue-modal .modal-actions,\n.return-modal .modal-actions {\n  padding: 0.75rem 1.25rem;\n  gap: 0.75rem;\n}\n\n.book-detail-preview {\n  background-color: var(--slate-50);\n  border-radius: var(--radius-lg);\n  padding: 0.75rem;\n  margin-bottom: 0.75rem;\n  border: 1px solid var(--slate-100);\n}\n\n.book-detail-grid {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 1rem;\n  align-items: start;\n}\n\n.book-detail-cover {\n  width: 120px;\n  height: 180px;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--bg-secondary);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n}\n\n.book-detail-cover img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.book-detail-cover-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: white;\n}\n\n.book-detail-cover-placeholder .material-symbols-outlined {\n  font-size: 64px;\n}\n\n.book-detail-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.book-detail-row {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.9375rem;\n}\n\n.book-detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.book-detail-label {\n  font-weight: 600;\n  color: var(--text-sub);\n  min-width: 90px;\n  flex-shrink: 0;\n}\n\n.book-detail-value {\n  color: var(--text-main);\n  font-weight: 500;\n}\n\n.book-info-summary {\n  background-color: var(--slate-50);\n  border-radius: var(--radius-lg);\n  padding: 1.25rem;\n  margin-bottom: 1.25rem;\n  border: 1px solid var(--slate-100);\n}\n\n.book-info-summary p {\n  margin: 0.5rem 0;\n  font-size: 0.875rem;\n  color: var(--text-sub);\n}\n\n.book-info-summary p:first-child {\n  margin-top: 0;\n}\n\n.book-info-summary p:last-child {\n  margin-bottom: 0;\n}\n\n.book-info-summary strong {\n  color: var(--text-main);\n  font-weight: 600;\n}\n\n/* Form Groups */\n.issue-modal .form-group,\n.return-modal .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  margin-bottom: 0.625rem;\n}\n\n.issue-modal .form-group:last-child,\n.return-modal .form-group:last-child {\n  margin-bottom: 0;\n}\n\n.issue-modal .form-label,\n.return-modal .form-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.issue-modal .form-input,\n.issue-modal .form-textarea,\n.return-modal .form-input,\n.return-modal .form-textarea {\n  padding: 0.45rem 0.75rem;\n  font-size: 0.9375rem;\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  transition: all var(--transition-fast);\n}\n\n.issue-modal .form-input:focus,\n.issue-modal .form-textarea:focus,\n.return-modal .form-input:focus,\n.return-modal .form-textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);\n  outline: none;\n}\n\n.issue-modal .form-input::placeholder,\n.return-modal .form-input::placeholder {\n  color: var(--slate-400);\n}\n\n/* Combobox */\n.combobox-container {\n  position: relative;\n}\n\n.combobox-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: var(--surface-light);\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 50;\n  margin-top: 0.25rem;\n  list-style: none;\n  padding: 0.25rem 0;\n}\n\n.combobox-option {\n  padding: 0.625rem 1rem;\n  cursor: pointer;\n  font-size: 0.9375rem;\n  color: var(--text-main);\n  transition: background-color var(--transition-fast);\n}\n\n.combobox-option:hover {\n  background-color: var(--slate-50);\n}\n\n.combobox-option.no-results {\n  color: var(--text-sub);\n  cursor: default;\n}\n\n.combobox-option.no-results:hover {\n  background-color: transparent;\n}\n\n/* Book dropdown specific styles */\n.book-dropdown {\n  max-height: 400px;\n  max-width: 600px;\n}\n\n.book-option {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--slate-100);\n}\n\n.book-option:last-child {\n  border-bottom: none;\n}\n\n.book-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.book-option-title {\n  font-weight: 600;\n  color: var(--text-main);\n  font-size: 0.9375rem;\n}\n\n.book-option-author {\n  font-size: 0.8125rem;\n  color: var(--text-sub);\n}\n\n.book-option-meta {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin-top: 0.125rem;\n}\n\n.book-option:hover .book-option-title {\n  color: var(--primary-color);\n}\n\n/* Required marker */\n.required {\n  color: var(--error-text);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .issue-modal .modal-header,\n  .return-modal .modal-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .issue-modal .modal-body,\n  .return-modal .modal-body {\n    padding: 0.75rem 1rem;\n  }\n\n  .issue-modal .modal-actions,\n  .return-modal .modal-actions {\n    padding: 0.75rem 1rem;\n  }\n\n  .book-detail-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .book-detail-cover {\n    width: 100%;\n    max-width: 120px;\n    height: 180px;\n    margin: 0 auto;\n  }\n\n  .book-detail-cover-placeholder {\n    max-width: 120px;\n    margin: 0 auto;\n  }\n}\n\n.form-help {\n  font-size: 0.75rem;\n  color: var(--slate-500);\n  margin-top: 0.375rem;\n}\n\n.loading-shelves {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem;\n  color: var(--slate-500);\n  font-size: 0.875rem;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.no-shelves-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1.5rem;\n  text-align: center;\n  color: var(--slate-400);\n  background-color: var(--slate-50);\n  border-radius: var(--radius-md);\n  border: 1px dashed var(--slate-200);\n}\n\n.no-shelves-message .material-symbols-outlined {\n  font-size: 2.5rem;\n  color: var(--slate-300);\n}\n\n.no-shelves-message p {\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.no-shelves-message .help-text {\n  font-size: 0.75rem;\n  color: var(--slate-400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
